(function () {
  'use strict';

  function packageLabel(input) {
    var label = input.closest('label');
    if (!label) return '';
    var span = label.querySelector('span');
    return span ? span.textContent.trim() : '';
  }

  function updateSummary(root) {
    var summary = root.querySelector('[data-package-summary]');
    if (!summary) return;

    var checked = root.querySelectorAll('[data-package-id]:checked');
    if (!checked.length) {
      summary.textContent = 'Select packages';
      return;
    }

    if (checked.length === 1) {
      summary.textContent = packageLabel(checked[0]);
      return;
    }

    summary.textContent = checked.length + ' packages selected';
  }

  function setOpen(root, open) {
    var trigger = root.querySelector('[data-package-summary-btn]');
    var panel = root.querySelector('[data-tcb-contact-packages-panel]');
    if (!trigger || !panel) return;

    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
    root.classList.toggle('is-open', open);
  }

  function initDropdown(root) {
    if (!root || root.dataset.boundPackageDropdown) return;
    root.dataset.boundPackageDropdown = '1';

    var trigger = root.querySelector('[data-package-summary-btn]');
    var panel = root.querySelector('[data-tcb-contact-packages-panel]');
    if (!trigger || !panel) return;

    trigger.addEventListener('click', function () {
      var open = trigger.getAttribute('aria-expanded') !== 'true';
      setOpen(root, open);
    });

    panel.querySelectorAll('[data-package-id]').forEach(function (input) {
      input.addEventListener('change', function () {
        updateSummary(root);
      });
    });

    document.addEventListener('click', function (event) {
      if (!root.classList.contains('is-open')) return;
      if (root.contains(event.target)) return;
      setOpen(root, false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        setOpen(root, false);
        trigger.focus();
      }
    });

    updateSummary(root);
  }

  function initAll() {
    document.querySelectorAll('[data-tcb-contact-package-dropdown]').forEach(initDropdown);
  }

  window.TcbContactPackages = {
    initAll: initAll,
    updateSummary: function (root) {
      if (root) updateSummary(root);
      else document.querySelectorAll('[data-tcb-contact-package-dropdown]').forEach(updateSummary);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
